import { Controller } from "@hotwired/stimulus";

export default class ClipboardController extends Controller {
  static values = { source: String };

  copy() {
    navigator.clipboard.writeText(this.sourceValue);
  }
}
